import { inject, Injectable } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SettingsService } from '@commoncore/services/settings.service';

@Injectable({
  providedIn: 'root'
})

class AppSettingsResolverService {

  constructor(private settingsService : SettingsService){

  }

  canResolve(route,state): Promise<boolean> | boolean {
    return this.settingsService.updateSettings();
  }

}

export const AppSettingsResolver: ResolveFn<boolean> = (route, state) => {
  return inject(AppSettingsResolverService).canResolve(route,state);
};